import { Flex, Box, Icon, Image, Text, Badge } from '@chakra-ui/react';
import React, { memo } from 'react';

import { IconBriefcase, IconFileClock, IconClock, IconBreakTime } from 'assets/icons';
// import { getLongLat } from 'containers/WhoIsWorking/shared/helpers';
import FallbackAvatar from 'components/FallbackAvatar';
import useTimeDuration from 'containers/WhoIsWorking/shared/useTimeDuration';
import FEATURES from 'global/features';
import { useFeatureList } from 'store/useFeatureStore';
import { formatMonthDayTime } from 'utils/format';

interface IWorkingEmployeeCardProps {
  item: any;
  activeEmployee: any;
  handleLocationClick: (item: any) => void;
}

const WorkingEmployeeCard: React.FC<IWorkingEmployeeCardProps> = ({ activeEmployee, item, handleLocationClick }) => {
  const timeDuration = useTimeDuration(item);

  const featureList: any = useFeatureList();

  return (
    <Flex
      borderRadius="md"
      border="1px"
      borderColor={item.user_id === activeEmployee?.user_id ? 'success.500' : 'gray.200'}
      px="4"
      py="2"
      key={item.user_id}
      cursor="pointer"
      bg={item.user_id === activeEmployee?.user_id ? '#F4FBF7' : 'white'}
      _hover={{ bg: 'secondary.50', borderColor: 'secondary.400' }}
      onClick={() => handleLocationClick(item)}
      data-testid={item.role}
    >
      {/* <Avatar borderRadius="md" size="sm" mr="2" /> */}
      <Image
        fallback={<FallbackAvatar name={item.first_name + ' ' + item?.last_name} boxSize="42px" />}
        boxSize="42px"
        objectFit="cover"
        borderRadius="base"
        src={item?.photo_url}
        alt={item?.first_name}
      />
      <Flex direction={{ base: 'column', md: 'row' }} justifyContent="space-between" flex="1 1 auto" ml="2">
        <Box>
          <Text mb="1" data-testid="full-name">
            {item?.first_name} {item?.last_name}
          </Text>
          {featureList[FEATURES.jobs] && item?.job_name ? (
            <Text fontSize="xs" color="gray.500" data-testid="job-name">
              <Icon as={IconBriefcase} fontSize="xs" mr="2" sx={{ '& path': { fill: 'gray.400' } }} />
              {item?.job_name}
            </Text>
          ) : null}
          {featureList[FEATURES.jobs] && item?.task_name ? (
            <Text fontSize="xs" color="gray.500" data-testid="task-name">
              <Icon as={IconFileClock} fontSize="xs" mr="2" />
              {item?.task_name}
            </Text>
          ) : null}
          {item?.current_break ? (
            <div data-testid="current-break">
              <Icon as={IconBreakTime} fontSize="xs" sx={{ '& path': { fill: 'gray.400' } }} mr="2" />
              <Badge px="2" textTransform="lowercase" borderRadius="base" colorScheme="primary" color="gray.500">
                {item?.current_break_name || 'Break'}
              </Badge>
            </div>
          ) : null}
        </Box>
        {item?.clock_in_time && !item?.clock_out_time ? (
          <Box mt={{ base: '2', md: '0' }} ml={{ md: '2' }} textAlign={{ md: 'right' }} flex="1 0 auto">
            <Text data-testid="duration">
              <Icon as={IconClock} fontSize="xs" mr="2" />
              {timeDuration}
            </Text>
            <Text fontSize="xs" color="gray.500" data-testid="clock-in-time">
              {formatMonthDayTime(item?.clock_in_time)}
            </Text>
            {item?.clockInTimezone ? (
              <Text fontSize="xs" color="gray.500" data-testid="clock-in-timezone">
                {item?.clockInTimezone}
              </Text>
            ) : (
              '-'
            )}
          </Box>
        ) : null}
      </Flex>
    </Flex>
  );
};

export default memo(WorkingEmployeeCard);
